import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";


export const TextOverImage = styled(Typography)`
	text-shadow: 0px 0px 16px rgba(0,0,0,.2), 0px 0px 8px rgba(0,0,0,1), 0px 0px 4px rgba(0,0,0,.7);
	color: white;
` as typeof Typography;
